// LookbookModal.jsx
import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import { useStore } from '../store';

export default function LookbookModal() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const isLookbookOpen = useStore((state) => state.isLookbookOpen);
  const setLookbookOpen = useStore((state) => state.setLookbookOpen);

  // Early return if modal is closed
  if (!isLookbookOpen) {
    return null;
  }

  // Lookbook data
  const lookbookImages = [
    {
      src: '/images/lookbook/01.jfif',
      description: 'I\'m going to elevate this world. One fitpic at a time.',
      rating: "♾️",
      user: "@iratefitpics"
    },
    {
      src: '/images/lookbook/02.jfif',
      description: '/fitpic/',
      rating: '-/10',
      user: "@forrealnow___"
    },
    {
      src: '/images/lookbook/03.jfif',
      description: '#FitPic',
      rating: '-/10',
      user: "@bee_lit"
    },
    {
      src: '/images/lookbook/04.jfif',
      description: 'Do yall like my $FITPIC ?',
      rating: '-/10',
      user: "@antivax_max",
    },
    {
      src: '/images/lookbook/05.jfif',
      description: 'This lovely lady said she liked my fit I liked hers so we took a fit pic 💯',
      rating: '-/10',
      user: "@bxksintokyo                                                                                         "
    },
    {
        src: '/images/lookbook/06.jfif',
        description: 'FitPic Final Boss',
        rating: '-/10',
        user: "@bloody_osiris"
    },
  ];

  // Navigate through images
  const goToNextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % lookbookImages.length);
  };

  const goToPreviousImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + lookbookImages.length) % lookbookImages.length);
  };

  // Handle image errors
  const handleImageError = (e) => {
    console.error(`Failed to load image: ${e.target.src}`);
    e.target.src = '/images/fallback.png';
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[9999]">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={() => setLookbookOpen(false)}
      />
      
      {/* Modal Content */}
      <div className="relative bg-white w-[min(95vw,550px)] md:w-[min(85vw,650px)] lg:w-[min(80vw,800px)] 
        h-[80vh] rounded-lg overflow-hidden shadow-2xl flex flex-col">
        {/* Close Button */}
        <button
          onClick={() => setLookbookOpen(false)}
          className="absolute top-4 right-4 z-20 bg-white/80 p-1.5 rounded-full hover:bg-white 
            transition-colors duration-200 text-gray-700 hover:text-black shadow-md"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Image Container */}
        <div className="w-full h-[60vh] overflow-hidden relative">
          <img
            src={lookbookImages[currentImageIndex].src}
            alt={lookbookImages[currentImageIndex].title}
            className="w-full h-full object-contain"
            onError={handleImageError}
          />
          
          {/* Navigation Controls */}
          <button
            onClick={goToPreviousImage}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white 
              text-gray-800 p-2.5 rounded-full transition-all duration-300 shadow-lg hover:scale-110"
            aria-label="Previous image"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          
          <button
            onClick={goToNextImage}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white 
              text-gray-800 p-2.5 rounded-full transition-all duration-300 shadow-lg hover:scale-110"
            aria-label="Next image"
          >
            <ChevronRight className="w-6 h-6" />
          </button>
          
          {/* Page Indicator Dots */}
          <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
            {lookbookImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentImageIndex(index)}
                className={`h-2.5 rounded-full transition-all duration-300 
                  ${currentImageIndex === index ? 'bg-white w-6' : 'bg-white/60 w-2.5'}`}
                aria-label={`Go to image ${index + 1}`}
              />
            ))}
          </div>
        </div>
        
        {/* Caption */}
        <div className="w-full bg-white p-5 text-black flex-shrink-0">
            <h3 className="text-xl sm:text-2xl font-semibold mb-1">
            {lookbookImages[currentImageIndex].description}
            </h3>
            <p className="text-gray-700 text-base sm:text-lg mt-2">
                Submitted by: <a 
                href={`https://x.com/${lookbookImages[currentImageIndex].user.replace('@', '')}`}
                className="text-blue-600 hover:underline"
                target="_blank"
                rel="noopener noreferrer"
                >
                {lookbookImages[currentImageIndex].user}
                </a>
            </p>
            <p>
                Rating:  {lookbookImages[currentImageIndex].rating}
            </p>
        </div>
    </div>
</div>
  );
}